<script lang="ts">
	import Navbar from '$lib/components/app/navbar.svelte';
	import Footer from '$lib/components/app/footer.svelte';
	import { setTheme } from 'mode-watcher';
	import SvelteSeo from 'svelte-seo';
	import { onMount } from 'svelte';

	let { data, children } = $props();

	onMount(() => {
		setTheme('customer');
	});
</script>

<svelte:head>
	<script
		defer
		src="https://umami-wgssw08044osc4ggkwoocww0.asge-akademie.de/script.js"
		data-website-id="4a57039d-8601-4a3e-b0c8-64bc692d21f6"
	></script>
</svelte:head>

<SvelteSeo />

<div class="flex min-h-svh flex-col">
	<Navbar user={data.userWithDetails} />
	<div class="container flex flex-1 flex-col">
		{@render children?.()}
	</div>
</div>
<Footer courseCategories={data.courseCategories} />
